import { useLanguage } from "../i18n";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden py-6 sm:py-8 border-y border-[#C69255]/15"
      style={{ backgroundColor: "#2C0F1A" }}
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display italic font-light text-2xl sm:text-3xl text-[#C69255]/75 px-6">
                  {item}
                </span>
                <svg width="10" height="10" viewBox="0 0 10 10" className="text-[#C69255]/40">
                  <rect x="2.5" y="2.5" width="5" height="5" transform="rotate(45 5 5)" fill="currentColor" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
